import { Modal, Stack } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useState, useEffect } from 'react';
import TagField from './TagField';

const modalsRoot = document.getElementById('root-modals') || document.body;

type Props = {
  show: boolean;
  handleClose: () => void;
  zipcodes: any;
  handleValueChange: (field: string, value: any) => void;
};
const errorText = 'All zip codes must be 5 digits.'
export const ZipCodeModal = ({ show, handleClose, zipcodes, handleValueChange }: Props) => {
  const [modifiedZipCode, setModifiedZipCode] = useState<any[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    setModifiedZipCode(zipcodes ? zipcodes : []);
  }, [zipcodes]);

  const validateZipCodes = (zipCodes: any[]) => {
    return zipCodes.every((zipcode) => /^\d{5}$/.test(zipcode));
  };

  const addzipcodeSetup = (value: string, id: string, type: string, add: boolean, tag: string, previousValue: string) => {
    if (add) {
      if (!modifiedZipCode.includes(value)) {
        setModifiedZipCode((prev) => {
          const newZipcodes = [...prev, value];
          if (validateZipCodes(newZipcodes)) {
            setErrorMessage('');
          } else {
            setErrorMessage(errorText);
          }
          return newZipcodes;
        });
      }
    } else {
      setModifiedZipCode((prev) => {
        const newZipcodes = prev.map((zipcode) => (zipcode === previousValue ? value : zipcode));
        if (validateZipCodes(newZipcodes)) {
          setErrorMessage('');
        } else {
          setErrorMessage(errorText);
        }
        return newZipcodes;
      });
    }
  };

  const removezipcodeSetup = (id: string, added: boolean, value: string) => {
    setModifiedZipCode((prev) => {
      const newZipcodes = prev.filter((zipcode) => zipcode !== value);
      if (validateZipCodes(newZipcodes)) {
        setErrorMessage('');
      } else {
        setErrorMessage(errorText);
      }
      return newZipcodes;
    });
  };

  const handleModalClose = () => {
    setModifiedZipCode(zipcodes ? zipcodes : []);
    setErrorMessage('');
    handleClose();
  };

  const handleModalSave = () => {
    if (validateZipCodes(modifiedZipCode)) {
      handleValueChange('zipcodes', modifiedZipCode);
      handleClose();
    } else {
      setErrorMessage(errorText);
    }
  };

  return createPortal(
    <Modal
      id='kt-modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-650px'
      show={show}
      onHide={handleModalClose}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>Zip Codes</h2>
      </div>
      <div className='h-400px mx-5'>
        <div className='mt-5 overflow-auto' style={{ maxHeight: '280px' }}>
          <Stack gap={5}>
            <TagField
              className='custom-zipcode'
              initialValue={zipcodes}
              name='zip codes'
              onAdd={addzipcodeSetup}
              onRemove={removezipcodeSetup}
            />
          </Stack>
        </div>
        {errorMessage && <div className='text-danger '>{errorMessage}</div>}
        <div className='mt-5 d-flex justify-content-end'>
          <button
            className='btn btn-primary me-6'
            data-kt-stepper-action='submit'
            onClick={handleModalClose}
          >
            Cancel
          </button>
          <button
            className='btn btn-primary'
            data-kt-stepper-action='submit'
            onClick={handleModalSave}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  );
};
